var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LayoutComponentDisplay } from "@/components/forms/components/layout/layoutComponentDisplay";
import copy from "fast-copy";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetAORChartValuesQuery, useGetAORConditionValuesQuery, useGetAORFieldsValuesQuery, } from "@/store/api";
import { ReportsTab } from "./reportsTab";
export var AORReports = function (_a) {
    var module = _a.module, viewType = _a.viewType, field_defs = _a.field_defs, record = _a.record, layoutMeta = _a.layoutMeta, view = _a.view, setRecord = _a.setRecord;
    var t = useTranslation(["AOR_Reports"]).t;
    var _b = useState(copy(record)), editedRecord = _b[0], setEditedRecord = _b[1];
    var _c = useState(copy(record)), editedFields = _c[0], setEditedFields = _c[1];
    var _d = useState([]), editedConditions = _d[0], setEditedConditions = _d[1];
    var _e = useState([]), editedCharts = _e[0], setEditedCharts = _e[1];
    var _f = useState(copy(record.report_module)), AORModule = _f[0], setAORModule = _f[1]; // Module pour l'arbre
    var _g = useState(copy(record.report_module)), moduleR = _g[0], setModuleR = _g[1]; // Module pour le champs
    var _h = useState("tab1"), activeTab = _h[0], setActiveTab = _h[1];
    var _j = useState(new Map()), validations = _j[0], setValidations = _j[1];
    var _k = useState(false), open = _k[0], setOpen = _k[1];
    var _l = useState([]), fieldsName = _l[0], setFieldsName = _l[1];
    var _m = useState([]), fieldsLabel = _m[0], setFieldsLabel = _m[1];
    var _o = useState([]), conditionsName = _o[0], setConditionsName = _o[1];
    var setParentValues = function (values) {
        var recData = __assign(__assign(__assign(__assign(__assign({}, editedFields), editedConditions), editedCharts), values), { report_type: "detail_report", relate_id: record.id, relate_to: "AOR_Reports" });
        setRecord(recData);
        setEditedRecord(recData);
    };
    var updateRecord = function (edited) {
        var record_module_temp = editedRecord.report_module;
        if (record_module_temp !== edited.report_module) {
            setAORModule(edited.report_module);
            setModuleR(edited.report_module);
            setOpen(false);
        }
        setParentValues(edited);
    };
    var updateReportsModule = function (m) {
        setModuleR(m);
    };
    /*const updateFieldname = (field: string) => {
      setEditedFields(editedRecord);
      if (activeTab === "tab1") {
        setFieldsName([...fieldsName, field]);
      } else if (activeTab === "tab2") {
        setConditionsName([...conditionsName, field]);
      }
    };*/
    var updateFieldname = function (fields) {
        setEditedFields(editedRecord);
        if (activeTab === "tab1") {
            setFieldsName(function (prev) { return __spreadArray(__spreadArray([], prev, true), fields, true); });
        }
        else if (activeTab === "tab2") {
            setConditionsName(function (prev) { return __spreadArray(__spreadArray([], prev, true), fields, true); });
        }
    };
    var _p = useState([]), fieldsValues = _p[0], setFieldsValues = _p[1];
    var fieldsValuesresponse = useGetAORFieldsValuesQuery({
        id: record.id,
    }).data;
    var _q = useState([]), conditionsValues = _q[0], setConditionsValues = _q[1];
    var conditionsValuesresponse = useGetAORConditionValuesQuery({
        id: record.id,
    }).data;
    var _r = useState([]), chartsValues = _r[0], setChartsValues = _r[1];
    var chartsValuesresponse = useGetAORChartValuesQuery({
        id: record.id,
    }).data;
    useEffect(function () {
        if (fieldsValuesresponse === null || fieldsValuesresponse === void 0 ? void 0 : fieldsValuesresponse.data.fieldsname) {
            setFieldsValues(fieldsValuesresponse === null || fieldsValuesresponse === void 0 ? void 0 : fieldsValuesresponse.data.fieldsname);
            var temp_1 = [];
            var temp2_1 = [];
            //let labels: any[] = [];
            fieldsValuesresponse === null || fieldsValuesresponse === void 0 ? void 0 : fieldsValuesresponse.data.fieldsname.map(function (item, index) {
                var _a;
                temp_1 = __spreadArray(__spreadArray([], temp_1, true), [item.field], false);
                temp2_1 = __spreadArray(__spreadArray([], temp2_1, true), [
                    (_a = {},
                        _a["aor_fields_id[".concat(index, "]")] = item.id || "",
                        _a["aor_fields_field[".concat(index, "]")] = item.field,
                        _a["aor_fields_display[".concat(index, "]")] = parseInt(item.display, 10) || 0,
                        _a["aor_fields_link[".concat(index, "]")] = parseInt(item.link) || 0,
                        _a["aor_fields_label[".concat(index, "]")] = item.label || "",
                        _a["aor_fields_field_function[".concat(index, "]")] = item.field_function || "",
                        _a["aor_fields_field_order[".concat(index, "]")] = item.field_order || index,
                        _a["aor_fields_format[".concat(index, "]")] = item.format || "",
                        _a["aor_fields_sort_by[".concat(index, "]")] = item.sort_by || "",
                        _a["aor_fields_group_by[".concat(index, "]")] = parseInt(item.group_by) || 0,
                        _a["aor_fields_total[".concat(index, "]")] = item.total || "",
                        _a["aor_fields_deleted[".concat(index, "]")] = 0,
                        _a["aor_fields_group_display[".concat(index, "]")] = parseInt(item.group_display) || 0,
                        _a.report_type = "detail_report",
                        _a.relate_id = record.id,
                        _a.relate_to = "AOR_Reports",
                        _a["aor_fields_module_path[".concat(index, "]")] = item.module_path[0],
                        _a),
                ], false);
                //labels.push(item.label);
            });
            setFieldsName(temp_1);
            setFieldsLabel(fieldsValuesresponse === null || fieldsValuesresponse === void 0 ? void 0 : fieldsValuesresponse.data.labels);
            setEditedFields(__assign(__assign({}, editedRecord), temp2_1.reduce(function (acc, curr) { return (__assign(__assign({}, acc), curr)); }, {})));
        }
    }, [fieldsValuesresponse]);
    useEffect(function () {
        if (conditionsValuesresponse && (conditionsValuesresponse === null || conditionsValuesresponse === void 0 ? void 0 : conditionsValuesresponse.data)) {
            setConditionsValues(conditionsValuesresponse === null || conditionsValuesresponse === void 0 ? void 0 : conditionsValuesresponse.data);
            var temp_2 = [];
            var temp2_2 = [];
            Object.values(conditionsValuesresponse === null || conditionsValuesresponse === void 0 ? void 0 : conditionsValuesresponse.data).map(function (item, index) {
                var _a;
                temp_2[item.condition_order] = item.field;
                temp2_2 = __spreadArray(__spreadArray([], temp2_2, true), [
                    (_a = {},
                        _a["aor_conditions_id[".concat(index, "]")] = item.id || "",
                        _a["aor_conditions_logic_op[".concat(index, "]")] = item.logic_op || "AND",
                        _a["aor_conditions_field[".concat(index, "]")] = item.field,
                        _a["aor_conditions_value[".concat(index, "]")] = item.value || "",
                        _a["aor_conditions_operator[".concat(index, "]")] = item.operator || "Equal_To",
                        _a["aor_conditions_value_type[".concat(index, "]")] = item.value_type || "Value",
                        _a["aor_conditions_order[".concat(index, "]")] = item.condition_order || "",
                        _a["aor_conditions_deleted[".concat(index, "]")] = 0,
                        _a["aor_conditions_parameter[".concat(index, "]")] = parseInt(item.parameter) || 0,
                        _a["aor_conditions_module_path[".concat(index, "]")] = item.module_path && item.module_path,
                        _a["aor_fields_format[".concat(index, "]")] = item.format || "",
                        _a),
                ], false);
            });
            setConditionsName(temp_2);
            setEditedConditions(__assign(__assign({}, editedRecord), temp2_2.reduce(function (acc, curr) { return (__assign(__assign({}, acc), curr)); }, {})));
        }
    }, [conditionsValuesresponse]);
    useEffect(function () {
        if (chartsValuesresponse && (chartsValuesresponse === null || chartsValuesresponse === void 0 ? void 0 : chartsValuesresponse.data)) {
            setChartsValues(chartsValuesresponse === null || chartsValuesresponse === void 0 ? void 0 : chartsValuesresponse.data);
            var temp = [];
            var temp2_3 = [];
            Object.values(chartsValuesresponse === null || chartsValuesresponse === void 0 ? void 0 : chartsValuesresponse.data).map(function (item, index) {
                var _a;
                temp2_3 = __spreadArray(__spreadArray([], temp2_3, true), [
                    (_a = {},
                        _a["aor_chart_id[".concat(index, "]")] = item.id || "",
                        _a["aor_chart_title[".concat(index, "]")] = item.name || "",
                        _a["aor_chart_type[".concat(index, "]")] = item.type,
                        _a["aor_chart_x_field[".concat(index, "]")] = item.x_field || "",
                        _a["aor_chart_y_field[".concat(index, "]")] = item.y_field || "",
                        _a),
                ], false);
            });
            //setConditionsName(temp);
            setEditedCharts(__assign(__assign({}, editedRecord), temp2_3.reduce(function (acc, curr) { return (__assign(__assign({}, acc), curr)); }, {})));
        }
    }, [chartsValuesresponse]);
    var getActiveTab = function (tab) {
        setActiveTab(tab);
    };
    var updateAORRecords = function (index, newSettings) {
        setEditedFields(function (prev) {
            var updated = __assign(__assign({}, prev), newSettings);
            setParentValues(updated);
            return updated;
        });
    };
    var fieldGraphe = field_defs === null || field_defs === void 0 ? void 0 : field_defs.graphs_per_row;
    var updateFieldValue = function (field, value) {
        setEditedRecord(function (prev) {
            var _a;
            var updated = __assign(__assign({}, prev), (_a = {}, _a[field] = value, _a));
            setParentValues(updated);
            setRecord(updated);
            return updated;
        });
    };
    return (_jsxs("div", __assign({ className: "flex flex-col w-full overflow-auto" }, { children: [_jsx("div", __assign({ className: "w-full" }, { children: _jsx(LayoutComponentDisplay, { module: module, viewType: viewType, fieldDefs: field_defs, record: editedRecord, fetchedRecord: record, layouts: (layoutMeta === null || layoutMeta === void 0 ? void 0 : layoutMeta.layout) || [], onHandleUpdate: updateRecord, validations: validations, viewScreen: view }) })), _jsx("div", __assign({ className: "w-full" }, { children: fieldsName && (_jsx(ReportsTab, { module: moduleR, fieldsname: fieldsName, conditionsname: conditionsName, updateSettings: updateAORRecords, record: editedRecord, fieldsValues: fieldsValues, conditionsValues: conditionsValues, chartsValues: chartsValues, updateActiveTab: getActiveTab, fieldsLabel: fieldsLabel, updateAORModuleList: updateReportsModule, isOpen: open, updateField: updateFieldname, fieldDefs: fieldGraphe, fetchedRecord: record, layouts: (layoutMeta === null || layoutMeta === void 0 ? void 0 : layoutMeta.layout) || [], onHandleUpdate: updateFieldValue, validations: validations, viewScreen: view })) }))] })));
};
